export default __webpack_public_path__ + "assets/oswaldo-cruz-component.db61a795.svg";